import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import Hero from "./pages/Hero";
import SignIn from "./pages/SignIn";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import Security from "./pages/Security";
import Proofs from "./pages/Proofs";
import ProofDetail from "./pages/ProofDetail";
import "./styles/global.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/leads/:leadId" element={<LeadDetail />} />
          <Route path="/proofs" element={<Proofs />} />
          <Route path="/proofs/:postId" element={<ProofDetail />} />
          <Route path="/security" element={<Security />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
